export const textStyles = {
  h4: {
    fontSize: '1.375rem',
  },
}
